import { AppContainer } from 'react-hot-loader';
import { IntlProvider } from 'react-intl';
import { Router } from 'react-router-dom';
import { loadDraftData, loadDraftSteps, updateDraftStep } from 'launch/actions/designBriefActions';
import { loadIntlDataForLocale } from 'common/utils/intl';
import { loadUrls } from 'launch/actions/urlActions';
import { loadUserData } from 'launch/actions/userActions';
import App from 'launch/components/App';
import BriefAttributeStore from './stores/BriefAttributeStore';
import BriefBookTypeStore from './stores/BriefBookTypeStore';
import BriefColorStore from './stores/BriefColorStore';
import BriefDesignStore from './stores/BriefDesignStore';
import BriefPackageTypeStore from './stores/BriefPackageTypeStore';
import BriefStore from './stores/BriefStore';
import DraftStepStore from './stores/DraftStepStore';
import DraftStore from './stores/DraftStore';
import FastClick from 'fastclick';
import Fluxible from 'fluxible';
import FluxibleComponent from 'fluxible-addons-react/FluxibleComponent';
import Modal from 'react-modal';
import React from 'react';
import ReactDOM from 'react-dom';
import UrlStore from 'launch/stores/UrlStore';
import UserStore from './stores/UserStore';
import history from 'common/utils/browserhistory';
let root = document.querySelector('[data-launch-app]');

let app = new Fluxible();
let ctx = app.createContext({});

app.registerStore(DraftStore);
app.registerStore(DraftStepStore);
app.registerStore(BriefDesignStore);
app.registerStore(BriefAttributeStore);
app.registerStore(BriefColorStore);
app.registerStore(BriefPackageTypeStore);
app.registerStore(BriefBookTypeStore);
app.registerStore(BriefStore);
app.registerStore(UserStore);
app.registerStore(UrlStore);

loadIntlDataForLocale(document.documentElement.lang).then(() => {
    const { user = {} } = window;

    ctx.getActionContext()
        .executeAction(loadDraftData, global.draft)
        .then(() =>
            ctx.getActionContext().executeAction(loadUserData, {
                isLoggedIn: user.isLoggedIn,
                isGDPRApplicable: user.isGDPRApplicable,
                locale: document.documentElement.lang,
            })
        )
        .then(() =>
            ctx.getActionContext().executeAction(loadUrls, {
                urls: global.urls,
            })
        )
        .then(() =>
            ctx.getActionContext().executeAction(loadDraftSteps, {
                steps: global.draftSteps,
                currentPath: window.location.pathname,
            })
        )
        .then(() => {
            // Render the app
            ReactDOM.render(
                <FluxibleComponent context={ctx.getComponentContext()}>
                    <IntlProvider
                        locale={document.documentElement.lang}
                        messages={global.intlData.messages}
                    >
                        <AppContainer>
                            <Router history={history}>
                                <App />
                            </Router>
                        </AppContainer>
                    </IntlProvider>
                </FluxibleComponent>,
                root
            );

            // Map the current route -> step
            history.listen(location => {
                ctx.getActionContext().executeAction(updateDraftStep, {
                    step: location.pathname.split('/').pop(),
                });
            });

            // Webpack Hot Module Replacement API
            module.hot && module.hot.accept();

            // Set up modal placeholder
            Modal.setAppElement(root);

            if ('addEventListener' in document) {
                document.addEventListener(
                    'DOMContentLoaded',
                    function() {
                        FastClick.attach(document.body);
                    },
                    false
                );
            }
        });
});
